import { h, Component } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import Router from 'preact-router';
import { Link } from 'preact-router/match';
import styles from '../css/app.css';
import _throttle from 'lodash/throttle';

// Import route views:
import WelcomePages from './routes/welcome-pages.jsx';
import BookPages from './routes/book-pages.jsx';
import SimpleTextPages from './routes/simple-text-pages.jsx';
import NotFound from './routes/not-found.jsx';

// Import some default data:
import { DefaultPalette, DefaultPosition } from '../utils-and-data/data.js';
import appEvents from '../utils-and-data/events.js';
import { 
  AboutEAP, AboutTheAuthor, 
  AboutTheBook, BookCredits 
} from '../utils-and-data/data.js';

// Import some web-workers for various data operations
import PagesWorker from '../workers/pages.worker.js';

// Import various partials && sensors
import CameraControl from './sensor-axs/camera-control.jsx';
import GeoLocation from './sensor-axs/geo-location.js';
import SideBar from './partials/side-bar.jsx';
import FxLayer from './partials/fx-layer.js';

// Use RootEl for initial component mount dom sizing etc:
var rootEl = document.getElementById('root');

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: DefaultPalette,
      position: DefaultPosition,
      pages: this.makeBlankPages(),
      dimensions: {
        width: rootEl.offsetWidth,
        height: rootEl.offsetHeight
      },
      childPage: '',
    };

    this._throttledResize = _throttle(this.onResize, 300);
    this.bookTitle = 'Breathe';

    // Setup new web-worker for page-loading...
    this.pagesWorker = new PagesWorker();
    this.pagesWorker.addEventListener('message', this.recievePages);
  }

  setLighting = (ev) => {
    this.setState({ lightsMode: ev.mode });
  }
  
  clearPageOne = () => {
    console.log('clear old out pages!!!');
    let newPages = this.state.pages;
    newPages[0] = { page_number: 1 };
    this.setState({ pages: newPages });
  }

  componentDidMount() {
    appEvents.on('clearPageOne', this.clearPageOne);
    appEvents.on('setLighting', this.setLighting);
    appEvents.on('hideHeader', this.hideHeader);
    appEvents.on('showHeader', this.showHeader);
    window.addEventListener('resize', this._throttledResize, {
      capture: true,
      passive: false
    });
    this.onResize();
  }

  onRouteChange = (ev) => {
    // console.log('on route change!!!', ev);

    // update UI to suit the route:
    this.trackSectionName(ev.url);
  }

  componentWillUnmount() {
    appEvents.removeListener('clearPageOne', this.clearPageOne);
    appEvents.removeListener('setLighting', this.setLighting);
    appEvents.removeListener('hideHeader', this.hideHeader);
    appEvents.removeListener('showHeader', this.showHeader);
  }

  // Lightly keep track of the current path, so that
  // templates can vary in styling slightly...
  trackSectionName(loc) {
    // console.log('trackSectionName', loc);
    if (loc === '/'
      || loc.indexOf('returning') !== -1) {

      this.cameraControl.stop();
      this.pagesWorker.postMessage({
        type: 'StopIntervals',
      });
      loc = '';
    }
    let page = loc.split('/').pop();
    this.setState({ childPage: page || null });
  }

  onResize = () => {
    let width = this.containerRef.offsetWidth;
    let height = this.containerRef.offsetHeight;
    if (this.state.dimensions.width !== width
      || this.state.dimensions.height !== height) {

      this.setState({
        dimensions: {
          width: width,
          height: height,
        }
      }, () => {
        FxLayer.resize(this.state.dimensions);
      });
    }
  }

  beginSensors = () => {
    // console.log('get sensor data!');
    this.geoLocation = this.geoLocation
      ? this.geoLocation
      : new GeoLocation({});
    this.cameraControl.start();
    return Promise.all([
      this.geoLocation.get(),
    ]);
  }

  beginLoaders = () => {
    console.log('BEGIN LOADERS');
    this.pagesWorker.postMessage({
      type: 'StopIntervals',
    });

    // First up, get device's sensor information:
    this.beginSensors().then(data => {

      // Absorb sensor data into state:
      this.setState({
        position: data[0],
      });

      // Lastly, use newly fetched sensor data,
      // To get dynamically rendered page data:
      this.beginFetches();
    }).catch(e => {
      // console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
      console.error(e);
    });
  }

  beginFetches = () => {

    // Figure out which pages are still missing and
    // request them for this fetch iteration:
    let missingPages = [];
    for (var i = 0; i < this.state.pages.length; i++) {
      if (!this.state.pages[i]) break;
      if (!this.state.pages[i].skipInCounts
        && !this.state.pages[i].paragraphs) {
        
        missingPages.push(i + 1);
      }
    }

    console.log('newly calced missingPages:', missingPages);

    // Figure out the start page:
    const startPage = history.state && history.state.panel 
      ?  history.state.panel + 1
      : 1;

    // Send the initial pages request off the the pages web-worker:
    this.pagesWorker.postMessage({
      type: 'GetInitialPages',
      coords: {
        latitude: this.state.position.latitude,
        longitude: this.state.position.longitude,
      },
      startPage: startPage,
      missingPages: missingPages,
      origin: location.origin
    });
  }

  recievePages = (response) => {
    console.log('REACT receivePages():', response.data);
    let newPages = this.state.pages;
    for (var i = 0; i < response.data.pages.length; i++) {
      let page = response.data.pages[i];
      newPages[page.page_number - 1] = page;
    }

    // Figure out which pages are still missing and
    // request them for this fetch iteration:
    let missingPages = [];
    for (var i = 0; i < newPages.length; i++) {
      if (!this.state.pages[i].skipInCounts
        && !this.state.pages[i].paragraphs) {
        
        missingPages.push(i + 1);
      }
    }

    // Ingest new pages to state:
    this.setState({
      pages: newPages,
      lastUpdateTime: response.data.timeStamp,
    });

    // Update the web-worker on the pages still missing...
    this.pagesWorker.postMessage({
      type: 'NewMissingPages',
      missingPages: missingPages
    });
  }

  recievePalette = (palette) => {
    console.log(palette);
    this.setState({ palette: palette });
  }

  toggleAppMenu = (e) => {
    console.log('toggle app menu');
    this.setState({ appMenuOpen: !this.state.appMenuOpen });
  }

  hideHeader = () => {
    this.setState({ childPage: null });
  }

  showHeader = () => {
    this.trackSectionName('/book');
  }

  storeRef(type, el) {
    // console.log('store a ref:', el);
    if (el !== null) this[type] = el;
  }

  render() {

    // Some state related vars to use down below:
    let section = this.state.childPage
      ? `${this.state.childPage}-section`
      : undefined;

    return (
      <div styleName='app'
        ref={a => this.storeRef('containerRef', a)}
        className={ClassNames(section, {
          'app-menu-open': this.state.appMenuOpen,
          'lights-out': this.state.lightsMode === 'dark'
        })}>

        <CameraControl ref={c => this.cameraControl = c}
          facing='environment'
          currentSection={this.state.childPage} />

        <header>
          <h5><Link href='/'>{this.bookTitle}</Link></h5>
          <button onClick={e => this.toggleAppMenu(e)} />
        </header>

        <SideBar toggleAppMenu={this.toggleAppMenu}
          bookTitle={this.bookTitle} />

        <Router onChange={this.onRouteChange}>

          <WelcomePages path="/"
            beginLoaders={this.beginLoaders}
            pages={this.state.pages}
            bookTitle={this.bookTitle}
            lastUpdateTime={this.state.lastUpdateTime} />

          <BookPages path="/book"
            pages={this.state.pages}
            beginLoaders={this.beginLoaders}
            dimensions={this.state.dimensions} />

          <BookPages path="/book"
            pages={this.state.pages}
            beginLoaders={this.beginLoaders}
            dimensions={this.state.dimensions} />

          <SimpleTextPages path="/about-eap"
            title={AboutEAP.title}
            paragraphs={AboutEAP.paragraphs} />

          <SimpleTextPages path="/credits"
            title={BookCredits.title}
            paragraphs={BookCredits.paragraphs} />

          <SimpleTextPages path="/about-book"
            title={AboutTheBook.title}
            paragraphs={AboutTheBook.paragraphs} />

          <SimpleTextPages path="/about-author"
            title={AboutTheAuthor.title}
            paragraphs={AboutTheAuthor.paragraphs} />

          <NotFound default />
        </Router>

        <iframe src="/rotate" id="rotate-banner"></iframe>
        <iframe src="/incompatible" id="incompatible-banner"></iframe>
        <iframe src="/desktop" id="desktop-banner"></iframe>
      </div>
    );
  }

  makeBlankPages() {
    let pageCount = parseInt(document.body.getAttribute('data-page-count'));
    let count = 0;
    let pages = [];
    while (count < pageCount) {
      pages.push({
        page_number: count + 1,
      });
      count++;
    }
    pages.push({
      skipInCounts: true,
      page_number: count + 1,
      ghost: {
        effect: 'EndPage'
      },
    });
    return pages;
  }
}

export default CSSModules(App, styles);



// WEBPACK FOOTER //
// ./app/frontend/components/app.jsx